export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.qrmenus.in/api/';
export const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || 'https://api.qrmenus.in';
export const CUSTOMER_MENU_URL = process.env.REACT_APP_CUSTOMER_MENU_URL || 'https://qrmenus.in';
export const SmartUltimateMonthly = process.env.SMART_ULTIMATE_MONTHLY || 'C9D1BF34-4CB5-4DC9-ACB7-ADF46ED0B04E';
export const SmartUltimateYearly =  process.env.SMART_ULTIMATE_YEARLY ||  '939ADFC2-D9E3-4643-95EC-E716C9C22879';


// export const API_BASE_URL = 'https://api.qrmenus.in/api/'
// export const IMAGE_BASE_URL='https://api.qrmenus.in'



// export const API_BASE_URL = 'https://stage-api.qrmenus.in/api/';
// export const IMAGE_BASE_URL = 'https://stage-api.qrmenus.in';
